import { combineReducers } from "@reduxjs/toolkit";
import jobReducer from "./features/job/jobSlice";
import jobListReducer from "./features/job list/jobListSlice";
import recentJobsReducer from "./features/job list/recentJobListSlice";
import domainReducer from "./domainSlice";
import contentConfigReducer from "./contentConfigurationSlice";

const rootReducer = combineReducers({
  job: jobReducer,
  jobs: jobListReducer,
  recentJobs: recentJobsReducer,
  domainName: domainReducer,
  contentConfig: contentConfigReducer,
});

export default rootReducer;
